import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/viber': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M444 49.9c42.2 36.7 65.6 117.9 49.8 246.5-15.2 124.6-109.1 136.6-125.7 142-7.2 2.3-70.3 18.1-152.5 11.2-9.1 10.5-21.1 24.3-29.8 33.7-15.9 17.1-25.7 33-42.3 27.8-13.8-4.2-13-25.1-13-25.1l0.1-51.6h-0.1c-120.1-33.8-118.4-158.4-117-224.9s14.3-120.2 50.9-156.8c65.8-60.4 200.9-52.3 200.9-52.3 114.6 0.5 166 37.8 178.7 49.5zM457.9 287c13.3-107.3-4.9-180.5-40.6-211.1-10.8-9.8-57.2-39-154.1-39.4 0 0-114.7-7.5-170.4 43-31 30.6-41.5 76.1-42.6 131.6-1.1 55.5-7.1 161.6 94.7 189.8-0.1 0-0.1 0 0 0 0 0-0.4 78.8-0.4 85.7-0.1 10.5 5.7 11 11 5.7 16.2-16.3 68.2-79 68.2-79 69.7 4.5 125.2-9.3 131.2-11.2 14-4.5 90.1-11.1 103-115.1zM318.9 206.2c0.4 8.6-12.5 9.2-12.9 0.6-1.1-22-11.4-32.7-32.6-33.9-8.6-0.5-7.8-13.4 0.7-12.9 27.9 1.5 43.4 17.5 44.8 46.2zM339.2 217.5c1-42.4-25.5-75.6-75.8-79.3-8.5-0.6-7.6-13.5 0.9-12.9 58 4.2 88.9 44.1 87.8 92.5-0.1 8.6-13.1 8.2-12.9-0.3zM386.2 230.9c0.1 8.6-12.9 8.7-12.9 0.1-0.6-81.5-54.9-125.9-120.8-126.4-8.5-0.1-8.5-12.9 0-12.9 73.7 0.5 133 51.4 133.7 139.2zM374.9 329v0.2c-10.8 19-31 40-51.8 33.3l-0.2-0.3c-21.1-5.9-70.8-31.5-102.2-56.5-16.2-12.8-31-27.9-42.4-42.4-10.3-12.9-20.7-28.2-30.8-46.6-21.3-38.5-26-55.7-26-55.7-6.7-20.8 14.2-41 33.3-51.8h0.2c9.2-4.8 18-3.2 23.9 3.9 0 0 12.4 14.8 17.7 22.1 5 6.8 11.7 17.7 15.2 23.8 6.1 10.9 2.3 22-3.7 26.6l-12 9.6c-6.1 4.9-5.3 14-5.3 14s17.8 67.3 84.3 84.3c0 0 9.1 0.8 14-5.3l9.6-12c4.6-6 15.7-9.8 26.6-3.7 14.7 8.3 33.4 21.2 45.8 32.9 7 5.7 8.6 14.4 3.8 23.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/viber.js
// module id = 1079
// module chunks = 0